"use client";

import adsBanner from "@/asset/images/ads_banner_pc.png";
import classNames from "classnames";
import Link from "next/link";
import Slider from "react-slick";
import FearAndGreedIndex from "./fearAndGreedIndex";
import { Button } from "antd";

interface AdsBannerProps {
  isSmallSize?: boolean;
  isOnlyAds?: boolean;
  rightComponent?: React.ReactNode;
}

export default function AdsBanner({
  isSmallSize = false,
  isOnlyAds = false,
  rightComponent = <FearAndGreedIndex />,
}: AdsBannerProps) {
  const sliderSettings = {
    dots: false,
    // infinite: true if 2 slides
    infinite: false,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    arrows: false,
  };

  const bannerSlides = [
    // Slide 1
    <Link key="slide1" href="https://bubbles.klarda.com" target="_blank">
      <div
        className={classNames(
          "flex flex-col bg-no-repeat bg-center bg-contain text-white p-2 lg:p-4 rounded-xl relative overflow-hidden",
          isSmallSize ? "gap-2 md:h-[180px]" : "gap-2 lg:gap-6 md:h-[180px]",
        )}
        style={{ backgroundImage: `url(${adsBanner.src})` }}
      >
        <Button
          type="primary"
          size="large"
          className={
            "absolute top-1/2 -translate-y-1/2 right-4 md:right-10 lg:right-12 w-fit rounded-full text-sm lg:text-base px-3 md:px-4"
          }
        >
          Get started
        </Button>
      </div>
    </Link>,
    // Slide 2
    // <Link
    //   key="slide2"
    //   href="https://blockchain.forum/?utm_source=website&utm_medium=referral&utm_campaign=klarda"
    //   target="_blank"
    //   className="py-2 lg:py-0"
    // >
    //   <div
    //     className={classNames(
    //       "flex flex-col bg-no-repeat bg-center bg-contain text-white rounded-xl h-20 ",
    //       isSmallSize ? "gap-2 md:h-[170px]" : "gap-2 lg:gap-6 md:h-[220px]",
    //     )}
    //     style={{ backgroundImage: `url(${imgBlockChainForum.src})` }}
    //   ></div>
    // </Link>,
  ];

  return (
    <div className={classNames("grid grid-cols-1 lg:grid-cols-12", isSmallSize ? "gap-2" : "gap-2 lg:gap-6")}>
      <div
        className={classNames("hidden md:block", isOnlyAds ? "col-span-1 lg:col-span-12" : "col-span-1 lg:col-span-8")}
      >
        <Slider {...sliderSettings}>{bannerSlides}</Slider>
      </div>

      <div className="col-span-1 lg:col-span-4">{rightComponent}</div>
    </div>
  );
}
